import React, { useState, useContext } from "react";
import axios from "axios";
import { useAlert } from "../../../AlertContext";
import { AuthContext } from "../../../AuthContext";
import { useNavigate } from "react-router-dom";
import InputField from "../../../Form/InputField";
import TextArea from "../../../Form/TextArea";
import { PlatformContext } from "../../../Platform/PlatformContext";
import { DashboardContext } from "../../DashboardContext";

const server_url = process.env.REACT_APP_BACKEND_URL;

const CreateTeamForm: React.FC = () => {
  const [teamName, setTeamName] = useState("");
  const [teamAcronym, setTeamAcronym] = useState("");
  const [teamLogo, setTeamLogo] = useState<File | null>(null);
  const [teamDescription, setTeamDescription] = useState("");
  const context = useContext(PlatformContext);
  const isMobile = !context?.isDesktop;

  const { showAlert } = useAlert();
  const navigate = useNavigate();
  const { session, setSession } = useContext(AuthContext);
  const { handleWithdraw } = useContext(DashboardContext);
  const closeRegistration = true;

  const handleLogoUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      const selectedFile = event.target.files[0];
      const allowedTypes = ["image/svg+xml", "image/png"];
      if (allowedTypes.includes(selectedFile.type)) {
        setTeamLogo(selectedFile);
      } else {
        showAlert("warning", "Please upload a svg. or png. file!");
        setTeamLogo(null);
      }
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!session) {
      showAlert("error", "Invalid session. Please try logging in again!");
      navigate("/login");
    }
    const access_token = session.access_token;

    const formData = new FormData();
    formData.append("teamName", teamName);
    formData.append("teamAcronym", teamAcronym);
    formData.append("teamDescription", teamDescription);
    formData.append("access_token", access_token);

    if (teamLogo) {
      formData.append("teamLogo", teamLogo);
    } else {
      showAlert("warning", "Please upload a team picture!");
      return;
    }
    setTeamName("");
    setTeamAcronym("");
    setTeamLogo(null);
    setTeamDescription("");

    try {
      const response = await axios.post(`${server_url}/addTeam`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.data.status) {
        showAlert(
          "success",
          "Your Team was created successfully! Please log in to see it!"
        );
        setSession(null);
        navigate("/login");
      } else {
        showAlert("error", response.data.error);
      }
    } catch (error) {
      console.error("Error occurred during form submission:", error);
      showAlert(
        "error",
        "An unexpected error occurred. Please try again later."
      );
    }
  };
  if (closeRegistration) {
    return (
      <div className="bg-white/10 p-6 rounded-xl shadow-lg w-full max-w-md">
        <h2 className="text-3xl font-semibold text-white mb-6">
          Registration is closed!
        </h2>
        <h3 className="text-white/80 text-md mb-6">
          Please contact an Admin to get more information!
        </h3>
      </div>
    );
  }
  return (
    <div className="bg-white/10 p-6 rounded-xl shadow-lg w-full max-w-md">
      <h2 className="text-3xl font-semibold text-white mb-6">
        Create a new Team
      </h2>
      <h3 className="text-white/80 text-md mb-6">
        After an Admin accepted your team, we will notify you!
      </h3>
      <form onSubmit={handleSubmit} className="space-y-2">
        <div>
          <label
            htmlFor="teamLogo"
            className="block text-white/90 text-md mb-1"
          >
            Teamlogo*
          </label>
          <input
            placeholder="Upload a team logo"
            type="file"
            accept=".svg, .png"
            onChange={handleLogoUpload}
            className="w-full text-sm bg-white/10 rounded-xl text-zinc-500 file:text-white file:mr-4 file:py-2 file:px-4 file:rounded-xl file:border-0 file:bg-inherit file:bg-blue-500"
            required
          />
        </div>
        <InputField
          type="text"
          value={teamName}
          onChange={(e) => setTeamName(e.target.value)}
          placeholder="Team name (check the rules!)"
          isMobile={isMobile}
          required
        />
        <InputField
          type="text"
          value={teamAcronym}
          onChange={(e) => setTeamAcronym(e.target.value)}
          placeholder="Team acronym (3 letters)"
          isMobile={isMobile}
          required
        />

        <div>
          <TextArea
            id="teamDescription"
            value={teamDescription}
            onChange={(e) => setTeamDescription(e.target.value)}
            className="w-full px-3 py-2 bg-white-200  focus:outline-none focus:shadow-[0_0_10px_black]"
            placeholder="Add some Information about you and why you want to create a team ..."
            rows={4}
            isMobile={isMobile}
            required
          />
        </div>

        <div>
          <button
            type="submit"
            className="w-full py-2 px-4 rounded-xl font-semibold text-white bg-blue-500  hover:bg-blue-600 focus:ring-2 "
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateTeamForm;
